import script from "./PayloadPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayloadPopup.vue?vue&type=script&setup=true&lang=ts"

import "./PayloadPopup.vue?vue&type=style&index=0&id=7697269a&lang=scss"

const __exports__ = script;

export default __exports__